export default {
  setMenuLang(path) {
    let menuLang = document.querySelectorAll('[data-footer="menu-lang"]')
    if (menuLang.length) {
      let href = menuLang[0].getAttribute('href')
      document.querySelectorAll('[data-footer="menu-lang"]')[0].setAttribute('href', href + path.substr(1))
    }
  },
  show(element) {
    element.style.display = ''
  },
  hide(element) {
    element.style.display = 'none'
  },
  setHeaderLogedIn() {
    let subscribe = document.querySelectorAll('[data-header="subscribe"]')
    let login = document.querySelectorAll('[data-header="login"]')
    let myaccount = document.querySelectorAll('[data-header="myaccount"]')
    let editMyInformations = document.querySelectorAll('[data-header="editmyinformations"]')
    let logout = document.querySelectorAll('[data-header="logout"]')

    if (subscribe.length) {
      this.hide(subscribe[0])
    }

    if (login.length) {
      this.hide(login[0])
    }

    if (myaccount.length) {
      this.show(myaccount[0])
    }

    if (editMyInformations.length) {
      this.show(editMyInformations[0])
    }

    if (logout.length) {
      this.show(logout[0])
    }
  },
  setHeaderLogedOut() {
    let subscribe = document.querySelectorAll('[data-header="subscribe"]')
    let login = document.querySelectorAll('[data-header="login"]')
    let myaccount = document.querySelectorAll('[data-header="myaccount"]')
    let editMyInformations = document.querySelectorAll('[data-header="editmyinformations"]')
    let logout = document.querySelectorAll('[data-header="logout"]')

    if (subscribe.length) {
      this.show(subscribe[0])
    }

    if (login.length) {
      this.show(login[0])
    }

    if (myaccount.length) {
      this.hide(myaccount[0])
    }

    if (editMyInformations.length) {
      this.hide(editMyInformations[0])
    }

    if (logout.length) {
      this.hide(logout[0])
    }
  }
}
